import { render, staticRenderFns } from "./RVBGridImprovements.vue?vue&type=template&id=176f747a&scoped=true"
import script from "./RVBGridImprovements.vue?vue&type=script&lang=js"
export * from "./RVBGridImprovements.vue?vue&type=script&lang=js"
import style0 from "./RVBGridImprovements.vue?vue&type=style&index=0&id=176f747a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176f747a",
  null
  
)

export default component.exports